/* eslint-disable */
import { CBSecureStorage, CBStorage } from './secure-storage';
import { CBNetwork } from './network';
import { CBCamera } from './camera';
import { CBBrowser } from './browser';
import { CBClipboard } from './clipboard';
import { CBAssistant } from './assistant';
import { CBAccessibility } from './accessibility';
import { CBGeolocation } from './geolocation';
import { CBEvent } from './event';
import { CBToken } from './token';
import { CBChecker } from './checker';
import { CBViewController } from './view-controller';
import { CBPermissions } from './permissions';
import { CBContacts } from './contacts';
import { CBShare } from './share';
import { CBOTP } from './otp';
import { CBSessionStorage } from './session-storage';

import {
  ChannelPlugin,
  KeyboardPlugin,
  DeepLinkPlugin,
  DeepLinkOptions,
  VibrationPlugin,
} from '@absis/core-plugins';

const CBKeyboard: KeyboardPlugin = {
  show: () => Promise.resolve(),
  hide: () => Promise.resolve(),
};
const CBDeepLink: DeepLinkPlugin = {
  /**
   * @deprecated use checkDeepLink method instead
   * @param _options
   */
  openUrl: (_options: DeepLinkOptions) => Promise.resolve({ completed: false }),

  /**
   * @deprecated use checkDeepLink method instead
   * @param _options
   */
  canOpenUrl: (_options: DeepLinkOptions) => Promise.resolve({ value: false }),
  checkDeepLink: (_options: DeepLinkOptions) =>
    Promise.resolve({ value: false, message: 'DesktopNotSupported' }),
  launchDeepLink: (_options: DeepLinkOptions) =>
    Promise.resolve({ completed: false, message: 'DesktopNotSupported' }),
};
const CBVibration: VibrationPlugin = {
  vibrate: () => {},
};
const DesktopPlugins: ChannelPlugin = {
  CBSecureStorage,
  CBToken,
  CBStorage,
  CBNetwork,
  CBCamera,
  CBBrowser,
  CBClipboard,
  CBViewController,
  CBKeyboard,
  CBAssistant,
  CBDeepLink,
  CBAccessibility,
  CBVibration,
  CBGeolocation,
  CBEvent,
  CBChecker,
  CBPermissions,
  CBContacts,
  CBShare,
  CBOTP,
  CBSessionStorage,
};
export { DesktopPlugins };
